import CustomForm from "../CustomForm";
import {ValidationError} from "../ICustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import {CheckboxItem} from "../../model/items/checkbox";
import {TextboxItem} from "../../model/items/textbox";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";
import Cell from "../../model/form/cell";

export default abstract class DateTime extends CustomForm {

    protected readonly variableName!: string;
    protected errorMessage: string|null = null;

    protected readonly checkboxes: CheckboxCell[] = [];
    protected readonly dateInputCell!: Cell;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of this.settings.form.grid.cells) {
            for (let cellItem of cell.cellItems) {
                if (cellItem instanceof CheckboxItem) {
                    this.checkboxes.push( new CheckboxCell(
                        cell,
                        this.onSetValue.bind(this),
                    ));
                } else if (!this.dateInputCell && cellItem instanceof TextboxItem) {
                    this.dateInputCell = cell;
                    this.variableName = cellItem.variableName;
                }
            }
        }
    }

    public onValidationErrors(errors: ValidationError[]): void {
        this.errorMessage = this.settings.app.messages.get('validateMessage');
    }

    public rewriteFormControls(): boolean {
        return true;
    }

    checkRequirements(): boolean {
        const form = this.settings.form;

        if (!this.variableName) {
            console.log('customForm-DateTime: variable for date save missing');
            return false;
        }

        if (!form.text) {
            console.log('customForm-DateTime: missing question text');
            return false;
        }

        if (!this.dateInputCell) {
            console.log('customForm-DateTime: missing datetime input field');
            return false;
        }


        return true;
    }

}